var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_20673",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 21,
    height: 21
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_20673)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_19_20673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.884 10.5634C22.5873 9.96839 21.2189 9.54401 19.8131 9.30094C19.8003 9.29844 19.787 9.30008 19.7752 9.30563C19.7634 9.31117 19.7536 9.32032 19.7473 9.33178C19.5723 9.64428 19.3773 10.0518 19.2406 10.3734C17.7251 10.1436 16.1836 10.1436 14.6681 10.3734C14.5155 10.0173 14.3439 9.66955 14.154 9.33178C14.1471 9.32082 14.1373 9.31207 14.1256 9.3066C14.1139 9.30112 14.1009 9.29916 14.0881 9.30094C12.6821 9.54309 11.3136 9.9675 10.0173 10.5634C10.0069 10.569 9.99783 10.5766 9.99063 10.5859C7.3973 14.4601 6.68646 18.2384 7.03563 21.9693C7.03638 21.9786 7.03906 21.9876 7.04351 21.9958C7.04796 22.0039 7.05408 22.0111 7.06146 22.0168C8.57112 23.1353 10.2599 23.9891 12.0556 24.5418C12.0683 24.5452 12.0817 24.5448 12.0942 24.5407C12.1066 24.5365 12.1176 24.5288 12.1256 24.5184C12.512 23.994 12.8537 23.4382 13.1473 22.8568C13.1514 22.8488 13.1538 22.8401 13.1542 22.8311C13.1547 22.8222 13.1533 22.8133 13.1501 22.8049C13.1468 22.7966 13.1419 22.789 13.1355 22.7827C13.1291 22.7764 13.1215 22.7716 13.1131 22.7684C12.5742 22.5626 12.0525 22.314 11.5531 22.0251C11.544 22.0198 11.5363 22.0123 11.5307 22.0033C11.5251 21.9943 11.5219 21.9841 11.5212 21.9736C11.5205 21.963 11.5225 21.9524 11.5269 21.9428C11.5313 21.9332 11.538 21.9248 11.5465 21.9184C11.6517 21.8398 11.7551 21.7587 11.8565 21.6751C11.8651 21.6675 11.8759 21.6627 11.8873 21.6612C11.8987 21.6597 11.9103 21.6617 11.9206 21.6668C15.194 23.1609 18.7373 23.1609 21.9723 21.6668C21.9827 21.6615 21.9945 21.6595 22.0061 21.661C22.0177 21.6624 22.0285 21.6674 22.0373 21.6751C22.1379 21.7579 22.2415 21.839 22.3481 21.9184C22.3565 21.9247 22.3631 21.933 22.3676 21.9424C22.372 21.9519 22.3741 21.9622 22.3736 21.9727C22.3731 21.9831 22.37 21.9933 22.3647 22.0022C22.3594 22.0112 22.352 22.0188 22.3431 22.0243C21.8447 22.3156 21.3226 22.5642 20.7823 22.7676C20.7739 22.7708 20.7662 22.7758 20.7599 22.7822C20.7535 22.7885 20.7485 22.7962 20.7453 22.8046C20.7421 22.813 20.7407 22.822 20.7412 22.831C20.7417 22.84 20.744 22.8488 20.7481 22.8568C21.0481 23.4384 21.3915 23.9918 21.769 24.5176C21.777 24.528 21.788 24.5357 21.8004 24.5398C21.8129 24.544 21.8263 24.5444 21.839 24.5409C23.6379 23.9906 25.3295 23.1366 26.8406 22.0159C26.8479 22.0106 26.854 22.0039 26.8586 21.9962C26.8631 21.9884 26.8661 21.9799 26.8673 21.9709C27.284 17.6568 26.169 13.9093 23.9098 10.5876C23.9046 10.5764 23.8954 10.5683 23.884 10.5634ZM13.6365 19.6968C12.6515 19.6968 11.839 18.7926 11.839 17.6809C11.839 16.5701 12.6356 15.6651 13.6365 15.6651C14.6448 15.6651 15.4498 16.5784 15.434 17.6818C15.434 18.7926 14.6373 19.6968 13.6365 19.6968ZM20.2823 19.6968C19.2965 19.6968 18.4848 18.7926 18.4848 17.6809C18.4848 16.5701 19.2806 15.6651 20.2823 15.6651C21.2906 15.6651 22.0956 16.5784 22.0798 17.6818C22.0798 18.7926 21.2915 19.6968 20.2823 19.6968Z",
    fill: "black"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_20673)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.95312,
    y: 6.92188,
    width: 20,
    height: 20,
    fill: "#E2E8F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_20673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6.95312 6.92188)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_19_20673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6.95312 6.92188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.edff8a17395aba245a9e8981b5698af4.svg";
export { ForwardRef as ReactComponent };